import config from '@/../config';

const apiUrl = process.env.API;
const port = process.env.API_PORT;

console.log(localStorage, 'localStorage');

// API base url.
const baseUrl = `http://${apiUrl}:${port}/api/${config.dev.api.version}`;

/**
 * Get method.
 * @param path
 * @returns {AxiosPromise}
 */
export function get(path) {
  return window.axios({
    method: 'GET',
    url: baseUrl + path
  })
}

/**
 * Delete method.
 * @param path
 * @returns {AxiosPromise}
 */
export function del(path) {
  return window.axios({
    method: 'DELETE',
    url: baseUrl + path
  })
}

/**
 * Put method.
 * @param path
 * @param data
 * @returns {AxiosPromise}
 */
export function put(path, data) {
  return window.axios({
    method: 'PUT',
    url: baseUrl + path,
    data
  });
}

/**
 * Post method.
 * @param path
 * @param data
 * @returns {AxiosPromise}
 */
export function post(path, data) {
  return window.axios({
    method: 'POST',
    url: baseUrl + path,
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/index.js